import styled from 'styled-components'

export const StyledBetaSpan = styled.span`
    color: rgb(34, 134, 58);
    background-color: white;
    border: 1px solid rgb(34, 134, 58);
    border-radius: 22px;
    font-size: 11px;
    font-weight: 500;
    line-height: 18px;
    padding: 2px 4px;
`
